import classNames from "classnames";
import React from "react";

import useWindowSize from "../../../hooks/getPageSize";
// styles
import styles from "./styles.module.scss";

interface Props {
  pagesCount: number;
  page: number;
  length: number;
  handlePaginationChange: (value: number) => void;
}

const Paginations: React.FC<Props> = ({
  length,
  page,
  pagesCount,
  handlePaginationChange,
}: Props): JSX.Element => {
  const [width] = useWindowSize();

  if (pagesCount < 2) return <></>;

  return (
    <div className={length ? styles.container : styles.hide}>
      <div dir="rtl" className={styles.list}>
        <div
          onClick={() => {
            page !== 1 && handlePaginationChange(page - 1);
          }}
          className={classNames(styles.prev, page == 1 && styles.disabled)}>
          {page == 1 ? (
            <img src="/assets/images/svg/arrowDark.svg" />
          ) : (
            <img
              className={styles.rotate}
              src="/assets/images/svg/arrowWhite.svg"
            />
          )}
        </div>
        {pagesCount !== 1 && (
          <li
            onClick={() => handlePaginationChange(1)}
            className={classNames(
              styles.page_item,
              page === 1 && styles.page_selected
            )}>
            {1}
          </li>
        )}

        {pagesCount > 5 && page !== 1 && (
          <li
            onClick={() => handlePaginationChange(1)}
            className={classNames(styles.dots_container)}>
            ...
          </li>
        )}

        {Array.from(Array(pagesCount > 2 ? pagesCount - 2 : 0), (e, i) => (
          <li
            onClick={() => handlePaginationChange(i + 2)}
            key={i}
            className={classNames(
              styles.page_item,
              page === i + 2 && styles.page_selected,
              (width < 900 ? page < i : page + 1 < i) || page > i + 2
                ? styles.page_item_hide
                : styles.page_item_flex
            )}>
            {i + 2}
          </li>
        ))}
        {pagesCount > 5 && page < pagesCount - 1 && (
          <li
            onClick={() => handlePaginationChange(1)}
            className={classNames(styles.dots_container)}>
            ...
          </li>
        )}

        <li
          onClick={() => handlePaginationChange(pagesCount)}
          className={classNames(
            styles.page_item,
            page === pagesCount && styles.page_selected
          )}>
          {pagesCount}
        </li>

        <div
          onClick={() => {
            page !== pagesCount && handlePaginationChange(page + 1);
          }}
          className={classNames(
            styles.next,
            page == pagesCount && styles.disabled
          )}>
          {page == pagesCount ? (
            <img
              className={styles.rotate}
              src="/assets/images/svg/arrowDark.svg"
            />
          ) : (
            <img src="/assets/images/svg/arrowWhite.svg" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Paginations;
